import { useAccountFilter, useSetAccountFilter } from '@gripp/shared-logic';
import {
  AccountSearchInput,
  countFilters,
  FilterHeaders,
  SlideAction,
  useSlideLayout,
  ViewMode,
} from '@gripp/shared-ui';
import { Pressable, StyleSheet, View } from 'react-native';
import { useNavigate } from 'react-router-dom';
import { AddButton } from '../../shared/components/addButton/addButton';

export const AccountsFilters = () => {
  const navigate = useNavigate();
  const { currentViewMode, onSlideChange } = useSlideLayout();

  const { data: accountFilter } = useAccountFilter();
  const { mutateAsync: setAccountFilter } = useSetAccountFilter();
  const filterCount = countFilters(accountFilter);

  const onInviteNavigate = async () => {
    if (currentViewMode === ViewMode.SINGLE) {
      await onSlideChange(SlideAction.DUAL);
    }

    navigate(`/account/invite`);
  };

  const onFilterNavigate = async () => {
    if (currentViewMode === ViewMode.SINGLE) {
      await onSlideChange(SlideAction.DUAL);
    }
    navigate('/accounts/filters');
  };

  return (
    <View style={styles.filtersContainer}>
      <FilterHeaders
        currentSearchKeyword={accountFilter?.keyword}
        searchComponent={<AccountSearchInput />}
        onFilterPress={onFilterNavigate}
        onSearchClose={() =>
          setAccountFilter({ ...accountFilter, keyword: '' })
        }
        filterCount={filterCount}
        Routes={{}}
      />
      <Pressable>
        <AddButton onPress={onInviteNavigate} />
      </Pressable>
    </View>
  );
};

const styles = StyleSheet.create({
  filtersContainer: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: 12,
  },
});
